import Joi from "joi-browser";

const constraintSchema = Joi.object()
    .keys({
        parameter: Joi.object().required().label("Parameter"),
        min: Joi.when(Joi.ref("max"), {
            is: Joi.any().valid(null, ""),
            then: Joi.number().min(0).label("Min"),
            otherwise: Joi.number().max(Joi.ref("max")).min(0).label("Min"),
        }),
        max: Joi.number().min(0).label("Max"),
        equals: Joi.number().min(0).label("Equals"),
    })
    .min(2);

const alertFormSchema = Joi.object().keys({
    name: Joi.string()
        .trim()
        .required()
        .label("Name")
        .error((errors) => {
            function errorsAsString() {
                return "is required";
            }
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(),
                },
            };
        }),
    material: Joi.object().required().label("Material"),
    parameterConstraints: Joi.array()
        .label("Alert Constraints")
        .items(constraintSchema),
    recipients: Joi.array().min(1).required().label("Alert Recipients"),
    notificationTypes: Joi.boolean()
        .valid(true)
        .label("Notification Types")
        .error((errors) => ({
            template: " {{message}}",
            context: {
                errors: errors.length,
                message: "needs to have at least one type selected",
            },
        })),
});

export default { alertFormSchema };
